import { CalendarException } from './calendar-exception';

export class Calendar { // exceptions calendar
    Id?: number;
    Name: string;
    Description: string;
    Exceptions?: CalendarException[];
    SiteId: number;
    UserId: number;
    exceptionsDates?: string[];

    constructor() {
        this.Name = '';
        this.Description = '';
    }
}
